import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './AdminButton.scss';
import classNames from 'classnames';
import Button from './Button';

export default class AdminButton extends Component {
    static propTypes = {
        type: PropTypes.string,
        kind: PropTypes.string,
        label: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    };

    render() {
        const {
            type,
            kind,
            label,
            className,
            disabled,
            onClick
        } = this.props;

        const buttonClassName = classNames(styles.button, className, {
            [styles.buttonSimple]: !kind,
            [styles.buttonEdit]: kind === 'edit',
            [styles.buttonBan]: kind === 'ban',
            [styles.buttonDelete]: kind === 'delete'
        });

        return (
            <Button type={type}
                    label={label}
                    className={buttonClassName}
                    disabled={disabled}
                    onClick={onClick}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/AdminButton.jsx